import { Box } from "@mui/material";
import { ParagraphText, UBAppModal } from "../../../../Libraries";
import styles from "./styles.module.css";
import { LanguageContext } from "../../../../context/LanguageContext";
import { useContext } from "react";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = "",
  message = "",
  htmlMessage,
  confirmText = "",
  cancelText = "",
  loading = false,
  id = "confirmation_modal",
  confirmButtonClassName = "ubDeleteButton",
  customClassName,
  style = {}
}) => {
  const [I18n] = useContext(LanguageContext);
  return (
    <UBAppModal
      id={id}
      open={open}
      header={{
        handleClose: !loading && onClose ? () => onClose() : () => { },
        dont_show_cross_icon: true,
      }}
      className={`${styles.confirmationModal} ${customClassName} confirmationModal`}
      sx={{ ...style }}
      footer={
        onClose ? [
          {
            data: {
              className: "ubSecondaryButton",
              title: cancelText || I18n.cancel,
              onClick: !loading ? () => onClose() : () => { },
              id: `${id}_cancel`,
            },
          },
          {
            data: {
              className: confirmButtonClassName,
              title: confirmText,
              onClick: onConfirm,
              disabled : loading,
              loading,
              id: `${id}_confirm`,
            },
          },
        ] :
          [
            {
              data: {
                className: confirmButtonClassName,
                title: confirmText,
                onClick: onConfirm,
                disabled : loading,
                loading,
                id: `${id}_confirm`,
              },
            },
          ]}
    >
      <Box>
        {htmlMessage ? (
          htmlMessage
        ) : (
          <ParagraphText className="fontSize16 fontWeight500 newFontColor">
            {message}
          </ParagraphText>
        )}
        {title ? (
          <ParagraphText className="fontSize14 fontWeight400 newLightColor mt-2">
            {title}
          </ParagraphText>
        ) : null}
      </Box>
    </UBAppModal>
  );
};

export default ConfirmationModal;
